module.exports = __webpack_public_path__ + "img/trash.feee89bd.svg";